
  const location = {
    path: "/location",
    name: "location",
    component: () => import(/* webpackChunkName: "location" */ "@/components/location/LocationIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "location" */ "@/components/location/LocationView.vue"), name: "locationView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "location" */ "@/components/location/LocationEdit.vue"), name: "locationEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "location" */ "@/components/location/LocationCreate.vue"), name: "locationCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default location;
    